(function () {
  var root = window.AWCartPromos || {};
  var config = root.hardwareBundle || root.freeLugs || {};

  if (!config.enabled) return;

  var state = {
    syncing: false,
    currentSync: null,
    pending: false,
    lastSignature: '',
    reloadCartAfterSync: false,
    reloadOnlyIfChanged: false,
    reloadingCart: false
  };

  function toInt(value) {
    var n = parseInt(value, 10);
    return isFinite(n) ? n : 0;
  }

  function normalizeList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (value) { return String(value || '').trim().toLowerCase(); })
      .filter(Boolean);
  }

  function normalizeIdList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (value) { return toInt(value); })
      .filter(function (value) { return value > 0; });
  }

  function lineProperty(item, key) {
    return item && item.properties && String(item.properties[key] || '') === 'true';
  }

  function linePropertyValue(item, key) {
    return item && item.properties ? item.properties[key] : null;
  }

  function isVariant(item, variantId) {
    return variantId > 0 && item && toInt(item.variant_id || item.id) === variantId;
  }

  function isProduct(item, productId) {
    return productId > 0 && item && toInt(item.product_id) === productId;
  }

  function isCartPage() {
    return window.location.pathname.replace(/\/$/, '') === '/cart';
  }

  function normalizeGift(gift, index) {
    var defaultVariantId = toInt(gift.defaultVariantId || gift.giftVariantId);
    var variantIds = normalizeIdList(gift.variantIds || gift.giftVariantIds);

    if (defaultVariantId && variantIds.indexOf(defaultVariantId) === -1) {
      variantIds.push(defaultVariantId);
    }

    return {
      key: String(gift.key || ('gift-' + index)),
      marker: String(gift.marker || ''),
      selectedVariantProperty: String(gift.selectedVariantProperty || ''),
      productId: toInt(gift.productId || gift.giftProductId),
      defaultVariantId: defaultVariantId,
      variantIds: variantIds
    };
  }

  var rawGifts = Array.isArray(config.gifts) ? config.gifts : [
    {
      key: 'lugNuts',
      marker: '_aw_free_lugs',
      selectedVariantProperty: '_aw_free_lugs_selected_variant',
      productId: config.giftProductId,
      defaultVariantId: config.giftVariantId,
      variantIds: config.giftVariantIds
    }
  ];
  var gifts = rawGifts
    .map(normalizeGift)
    .filter(function (gift) {
      return gift.marker && gift.defaultVariantId && (gift.productId || gift.variantIds.length);
    });

  if (!gifts.length) return;

  var minWheelQty = Math.max(1, toInt(config.minWheelQty) || 4);
  var eligibleProductType = String(config.eligibleProductType || 'Wheels').toLowerCase();
  var excludedProductTypes = normalizeList(config.excludedProductTypes);
  var excludedHandles = normalizeList(config.excludedHandles);
  var autoAddGift = config.autoAddGift === true;

  function isGift(item, gift) {
    var variantId = toInt(item && (item.variant_id || item.id));
    return isProduct(item, gift.productId) || gift.variantIds.indexOf(variantId) !== -1;
  }

  function isAnyGift(item) {
    return gifts.some(function (gift) { return isGift(item, gift); });
  }

  function isExcludedBundleLine(item) {
    if (!item) return false;

    var productType = String(item.product_type || '').trim().toLowerCase();
    if (productType && excludedProductTypes.indexOf(productType) !== -1) return true;

    var handle = String(item.handle || '').trim().toLowerCase();
    return handle && excludedHandles.indexOf(handle) !== -1;
  }

  function isEligibleWheel(item) {
    if (!item || isAnyGift(item) || isExcludedBundleLine(item)) return false;
    return String(item.product_type || '').trim().toLowerCase() === eligibleProductType;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not read cart');
      return res.json();
    });
  }

  function addItems(items) {
    if (!items.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not add promo items');
      return res.json();
    });
  }

  function updateCart(updates) {
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not update cart');
      return res.json();
    });
  }

  function normalizeProperties(properties) {
    var normalized = {};
    if (!properties) return normalized;

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value === null || typeof value === 'undefined') return;
      normalized[key] = value;
    });

    return normalized;
  }

  function changeItem(change) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(change)
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not change promo item');
      return res.json();
    });
  }

  function changeItems(changes) {
    return changes.reduce(function (promise, change) {
      return promise.then(function () { return changeItem(change); });
    }, Promise.resolve());
  }

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      var giftState = gifts.map(function (gift) {
        return lineProperty(item, gift.marker) ? gift.key : '';
      }).join(',');

      return [
        item.key,
        item.variant_id || item.id,
        item.product_id || '',
        item.quantity,
        item.product_type,
        item.handle,
        item.final_line_price,
        giftState,
        lineProperty(item, '_aw_auto_gift') ? 'autoGift' : '',
        lineProperty(item, '_tsb') ? 'tsb' : ''
      ].join(':');
    }).join('|') + '::' + (cart.total_discount || 0);
  }

  function isAllowedGiftVariantId(gift, variantId) {
    variantId = toInt(variantId);
    if (!variantId) return false;
    return gift.variantIds.length
      ? gift.variantIds.indexOf(variantId) !== -1
      : variantId === gift.defaultVariantId;
  }

  function selectedGiftVariantId(items, gift) {
    var selected = 0;

    if (gift.selectedVariantProperty) {
      items.forEach(function (item) {
        if (!isEligibleWheel(item)) return;
        var variantId = toInt(linePropertyValue(item, gift.selectedVariantProperty));
        if (isAllowedGiftVariantId(gift, variantId)) selected = variantId;
      });
    }

    return selected || gift.defaultVariantId;
  }

  function giftProperties(gift, autoAdded) {
    var properties = {};
    properties[gift.marker] = 'true';
    if (autoAdded) properties._aw_auto_gift = 'true';
    return properties;
  }

  function plan(cart) {
    var items = cart.items || [];
    var wheelQty = items.reduce(function (sum, item) {
      return isEligibleWheel(item) ? sum + toInt(item.quantity) : sum;
    }, 0);
    var qualifies = wheelQty >= minWheelQty;
    var updates = {};
    var additions = [];
    var changes = [];

    gifts.forEach(function (gift) {
      var giftLines = items.filter(function (item) { return isGift(item, gift); });
      var markedLine = giftLines.find(function (item) { return lineProperty(item, gift.marker); });
      var desiredVariantId = selectedGiftVariantId(items, gift);

      if (qualifies) {
        if (!giftLines.length && autoAddGift) {
          additions.push({
            id: desiredVariantId,
            quantity: 1,
            properties: giftProperties(gift, true)
          });
          return;
        }

        if (!markedLine && giftLines.length) {
          var firstGiftLine = giftLines[0];
          var firstGiftQty = Math.max(1, toInt(firstGiftLine.quantity));

          if (firstGiftQty === 1) {
            var properties = normalizeProperties(firstGiftLine.properties);
            properties[gift.marker] = 'true';
            changes.push({
              id: firstGiftLine.key,
              quantity: 1,
              properties: properties
            });
          } else {
            additions.push({
              id: toInt(firstGiftLine.variant_id || firstGiftLine.id) || desiredVariantId,
              quantity: 1,
              properties: giftProperties(gift, false)
            });
            updates[firstGiftLine.key] = firstGiftQty - 1;
          }
        }
      } else if (config.removeAutoGiftWhenIneligible !== false) {
        giftLines.forEach(function (item) {
          if (lineProperty(item, '_aw_auto_gift')) updates[item.key] = 0;
        });
      }
    });

    return {
      qualifies: qualifies,
      additions: additions,
      updates: updates,
      changes: changes,
      changed: additions.length > 0 || Object.keys(updates).length > 0 || changes.length > 0
    };
  }

  function notifyUpdated() {
    fetchCart().then(function (cart) {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      window.dispatchEvent(new CustomEvent('aw:cart-promo-synced', { detail: cart }));
    }).catch(function () {});
  }

  function maybeReloadCartPage() {
    if (!state.reloadCartAfterSync || state.reloadingCart || !isCartPage()) return;

    state.reloadCartAfterSync = false;
    state.reloadOnlyIfChanged = false;
    state.reloadingCart = true;

    setTimeout(function () { window.location.reload(); }, 700);
  }

  function sync() {
    if (state.syncing) {
      state.pending = true;
      return state.currentSync || Promise.resolve(false);
    }

    state.syncing = true;
    state.pending = false;
    state.currentSync = fetchCart()
      .then(function (cart) {
        var signature = cartSignature(cart);
        if (signature === state.lastSignature) return false;
        state.lastSignature = signature;

        var next = plan(cart);
        if (!next.changed) {
          if (state.reloadOnlyIfChanged) {
            state.reloadCartAfterSync = false;
            state.reloadOnlyIfChanged = false;
          } else {
            maybeReloadCartPage();
          }
          return false;
        }

        return changeItems(next.changes)
          .then(function () { return addItems(next.additions); })
          .then(function () { return updateCart(next.updates); })
          .then(function () {
            state.lastSignature = '';
            notifyUpdated();
            maybeReloadCartPage();
            return true;
          });
      })
      .catch(function (err) {
        console.warn('[AWCartPromos] sync failed:', err);
        return false;
      })
      .finally(function () {
        state.syncing = false;
        state.currentSync = null;
        if (state.pending) setTimeout(sync, 150);
      });

    return state.currentSync;
  }

  function schedule(options) {
    options = options || {};
    if (options.reloadCartAfterSync && isCartPage()) {
      state.reloadCartAfterSync = true;
      state.reloadOnlyIfChanged = options.reloadOnlyIfChanged === true;
    }

    setTimeout(sync, options.reloadCartAfterSync ? 700 : 200);
  }

  function withTimeout(promise, timeoutMs) {
    return Promise.race([
      promise,
      new Promise(function (resolve) { setTimeout(resolve, timeoutMs); })
    ]);
  }

  function syncBeforeCheckout(event) {
    if (!config.syncBeforeCheckout) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var checkout = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.dataset.awPromoSynced === 'true') return;

    var checkoutUrl = checkout.tagName === 'A' ? checkout.href : '/checkout';

    event.preventDefault();
    checkout.setAttribute('aria-busy', 'true');

    withTimeout(sync().then(function () { return sync(); }), 5000)
      .then(function () {
        checkout.dataset.awPromoSynced = 'true';
        checkout.removeAttribute('aria-busy');
        window.location.href = checkoutUrl;
      })
      .finally(function () {
        checkout.disabled = false;
        checkout.removeAttribute('aria-busy');
      });
  }

  window.AWCartPromos = root;
  window.AWCartPromos.syncHardwareBundle = sync;
  window.AWCartPromos.syncFreeLugs = sync;

  function initialSync() {
    schedule({
      reloadCartAfterSync: isCartPage(),
      reloadOnlyIfChanged: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

  ['cart:updated', 'cart:refresh', 'cartcount:update', 'theme:cart:change', 'cart-token-updated'].forEach(function (eventName) {
    window.addEventListener(eventName, schedule);
  });

  [
    'addToCartButtonClicked',
    'candyrack-offer-added',
    'candyrack-offer-removed',
    'candyrack-closed',
    'ppp-candyrack-button-layout-offers-added-to-cart',
    'ppp-candyrack-checkbox-layout-offers-added-to-cart'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      schedule({ reloadCartAfterSync: isCartPage() });
    });
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-aw-free-lugs-choice]')) {
      var offer = event.target.closest('[data-aw-free-lugs-offer]');
      var input = offer && offer.querySelector('[data-aw-free-lugs-selected-variant]');
      if (input) input.value = event.target.value;

      if (offer) {
        offer.querySelectorAll('.aw-free-lugs-offer__choice').forEach(function (choice) {
          choice.classList.toggle('aw-free-lugs-offer__choice--selected', choice.contains(event.target));
        });
      }
    }

    if (event.target && event.target.matches && event.target.matches('input[name="updates[]"], input[data-quantity-input], .quantity-selector__input')) {
      schedule({ reloadCartAfterSync: true });
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('button[name="plus"], button[name="minus"], [data-quantity-button], [data-quantity-plus], [data-quantity-minus]')) {
      schedule({ reloadCartAfterSync: true });
    }
  });

  document.addEventListener('click', syncBeforeCheckout, true);
})();
